




































































































































import { Component, Vue } from 'vue-property-decorator';
import Aircraft from '@/store/entities/flight/aircraft';
@Component({})
export default class AddAircraftType extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  aircraft: Aircraft = new Aircraft();
  isEdit: boolean = false;

  data() {
    return {
      title: 'Preliminary report',
      email: '',
      rules: {
        required: (value) => !!value || 'Zorunlu Alan.',
      },
    };
  }

  created() {

    this.aircraft = this.$store.state.aircraft.editAircraft;
    if (this.aircraft == null) {
      this.isEdit = false;
      this.aircraft = new Aircraft();
    } else {
      this.isEdit = true;
    }
  }

  async saveAircraft() {

    if (!this.isEdit) {
      await this.$store.dispatch({
        type: 'aircraft/saveAircraft',
        data: this.aircraft,
      });

      Vue.$toast.success('Kayıt Eklendi');
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: 'aircraft/saveAircraft',
        data: this.aircraft,
      });

      Vue.$toast.success('Kayıt Güncellendi');

      this.closeDialog();
    }
  }

  closeDialog() {
    this.$emit('closed');
  }
  cancelDialog() {
    this.$emit('cancel');
    this.$store.state.aircraft.editAircraft = null;
  }
}
